import { AnyAction } from 'redux';

const initialState = {
  isLoading: false,
  hideContent: true,
  suppressEventListeners: false,
};

export const pageLoadingReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'FRONTASTIC_BRIDGE_PAGE_LOAD_START':
      return {
        ...state,
        isLoading: true,
        hideContent: true,
        suppressEventListeners: false,
      };
    case 'FRONTASTIC_BRIDGE_PAGE_LOAD_START_WITHOUT_HIDDEN_CONTENT':
      return {
        ...state,
        isLoading: true,
        hideContent: false,
        suppressEventListeners: false,
      };
    case 'FRONTASTIC_BRIDGE_PAGE_LOAD_DONE':
      return {
        ...state,
        isLoading: false,
        hideContent: true, // back to default? might not be necessary
        suppressEventListeners: false,
      };
    case 'FRONTASTIC_BRIDGE_SUPPRESS_EVENT_LISTENERS':
      return {
        ...state,
        suppressEventListeners: true,
      };
    case 'FRONTASTIC_BRIDGE_DONT_SUPPRESS_EVENT_LISTENERS':
      return {
        ...state,
        suppressEventListeners: false,
      };
  }

  return state;
};
